/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import { DefaultTheme } from 'styled-components/native'

import { ColorsType, TextColorKey } from 'theme/types'

import { LinkColor } from './types'

type LinkState = 'default' | 'hover' | 'visited'

const linkTextColorKey: Record<LinkColor, Record<LinkState, TextColorKey>> = {
  brand: {
    default: 'brandPrimary',
    hover: 'brandPrimaryHover',
    visited: 'brandSecondaryHover',
  },
  neutral: {
    default: 'default',
    hover: 'brandPrimaryHover',
    visited: 'brandSecondaryHover',
  },
}

const getLinkState = ({
  hovered,
  visited,
}: {
  hovered?: boolean
  visited?: boolean
}): LinkState => {
  if (visited) return 'visited'
  if (hovered) return 'hover'

  return 'default'
}

export function getLinkTextColor({
  color,
  hovered,
  visited,
  theme,
}: {
  color: LinkColor
  hovered?: boolean
  visited?: boolean
  theme: DefaultTheme
}): ColorsType {
  const state = getLinkState({ hovered, visited })
  const colorKey = linkTextColorKey[color][state]

  return theme.designSystem.color.text[colorKey]
}
